import React from 'react';

const capabilities = [
  { icon: '🏗️', title: 'Lakehouse Architecture', desc: 'Design and implement Delta Lake-based lakehouses on Azure, AWS, or GCP for unified analytics.' },
  { icon: '⚙️', title: 'Data Engineering', desc: 'Build robust ETL/ELT pipelines with Apache Spark, Lakeflow, and dbt on Databricks.' },
  { icon: '📊', title: 'Business Intelligence', desc: 'Deliver real-time dashboards with Databricks AI/BI and Genie, plus Power BI, Tableau, and Looker.' },
  { icon: '🧬', title: 'Mosaic AI & MLflow', desc: 'Deploy GenAI agents and ML workflows with Mosaic AI, Agent Bricks, and MLflow model serving.' },
  { icon: '🔒', title: 'Unity Catalog & Governance', desc: 'Implement fine-grained access control and data lineage with Unity Catalog.' },
  { icon: '💰', title: 'Cost Optimization', desc: 'Right-size clusters, leverage spot instances, and optimize DBU spend across workspaces.' },
];

const DatabricksConsulting = () => {
  return (
    <section id="databricks" className="py-20 bg-gradient-to-br from-orange-50 to-red-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
            🧱 Databricks
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Databricks Consulting & Implementation
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Unlock the full power of the Databricks Data Intelligence Platform — from lakehouse migrations to production ML pipelines — with certified Databricks partners.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-14">
          {capabilities.map((c, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-orange-100">
              <div className="text-4xl mb-3">{c.icon}</div>
              <h4 className="font-bold text-gray-900 text-lg mb-2">{c.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>

        {/* Process strip */}
        <div className="bg-white rounded-2xl p-8 shadow-md border border-orange-100">
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">Our Databricks Engagement Process</h3>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 text-center">
            {['Discovery & Assessment', 'Architecture Design', 'Implementation & Migration', 'Optimization & Support'].map((step, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-600 text-white flex items-center justify-center font-bold mb-2">
                  {i + 1}
                </div>
                <p className="text-gray-700 font-medium text-sm">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DatabricksConsulting;
